import _color from '@/assets/utils/color.js';
<template>
  <div class="mx-auto w-full">
    <vx-card>
      <div class="columns">
        <div
          class="column is-narrow mt-8"
          style="width: 200px; text-align: right"
        >
          <span>รหัส</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 150px">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              label-placeholder="code"
              v-model="code"
              :readonly="readonly"
              @blur="$v.code.$touch()"
            />
            <p v-if="$v.code.$error & $v.code.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div class="column is-narrow" style="width: 200px; text-align: right">
          <span>ชื่อ</span>
        </div>
        <div class="column is-narrow mt-1">
          <div style="width: 400px">
            <vs-input
              class="w-full -mt-3"
              icon-pack="feather"
              icon="icon-user"
              icon-no-border
              label-placeholder="Name"
              v-model="name"
              @blur="$v.name.$touch()"
            />
            <p v-if="$v.name.$error & $v.name.$dirty">
              Please Enter Required Data
            </p>
          </div>
        </div>
      </div>

      <div class="columns mt-3">
        <div class="column is-narrow" style="width: 200px; text-align: right">
          <span>หมายเหตุ</span>
        </div>
        <div class="column is-narrow mt-1">
          <div style="width: 400px">
            <vs-input
              class="w-full -mt-3"
              icon-pack="feather"
              icon="icon-book"
              icon-no-border
              label-placeholder="Remark"
              v-model="remark"
            />
          </div>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            class="mr-3 mb-2"
            @click="onSubmit"
            :disabled="$v.$anyError"
            >Submit</vs-button
          >
          <vs-button color="warning" type="border" class="mb-2" @click="clsd"
            >Back</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import moment from "moment"; // use for Datetime

import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      agentscode: "",
      parentagent: "",
      parentagent2: "",
      userid: "",
      code: "",
      name: "",
      remark: "",
      email: "",
      readonly: false,
      configdateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d",
      },
      times: null,
      configTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
      },
      addressCode: null,
      custGroupsCode: null,
    };
  },
  validations: {
    code: {
      required,
    },
    name: {
      required,
    },
  },
  components: {
    Datepicker,
    // addresss,
    // ports
  },
  props: ["acstate", "recid"],
  methods: {
    clsd: function () {
      // console.log(this.times);

      let vm = this;
      vm.$emit("grid");

      // this.refnum = this.pol = this.pod = this.plod = this.tlicense1 = this.tlicensep1 = this.tlicensec1 = this.tlicenseb1 = this.carbrand = this.rficc_code = this.rfprv_code = this.clicense = this.driverid = this.drivername = this.ffbranch = this.ffnumber = this.mabl = this.transmodes_id = this.times =
      //   "";
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
      }
    },
    async onSubmit() {
      // alert("Hi");
      this.$v.$touch();

      let vm = this;

      if (this.$v.$invalid) {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Data Not Complete",
          text: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
        return;
      }

      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      const formData = {
        // agentscode: this.agentscode,
        // parentagent: this.parentagent,
        code: this.code,
        name: this.name,
        remark: this.remark,
        editor: String(this.userid),
        acstate: this.acstate,
      };

      if (token) {
        try {
          const response = await axios.post(
            `${BASE_API_URL}/auth-svc/companygroups/create`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response.data.message,
            });
            vm.$emit("grid");
          }
        } catch (error) {
          // return error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/pages/login/");
        }
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        try {
          // const response = await axios.get(`${BASE_API_URL}/auth/profile`, {
          //   headers: { Authorization: "Bearer " + token.accessToken }
          // });

          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;
          this.email = decoded.email;

          this.addressCode = decoded.addressCode;
          this.custGroupsCode = decoded.custGroupsCode;
          // console.log(decoded);
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/pages/login/");
        }
      }
    },
  },
  async created() {
    // console.log(this.recid);
    // console.log("create");
    this.checkProfiles();

    if (this.recid != "0") {
      // alert("Edit");

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          // const response = await axios.post(`${BASE_API_URL}/agents/findall`, formData);

          const response = await axios.get(
            `${BASE_API_URL}/auth-svc/companygroups/${this.recid}`,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data);
          // console.log(response.data.code)

          if (!response.data) {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            this.code = response.data.code;
            this.name = response.data.name;
            this.remark = response.data.remark;
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        this.$router.replace("/pages/login/");
      }
    } else {
      let vm = this;
      vm.readonly = false;
      // vm.clsd();
    }
  },
};
</script>

<style scoped>
p {
  color: red;
}
</style>
